"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.careLinkLookupKey = exports.PatientNotFoundError = void 0;
exports.requirePatientAccess = requirePatientAccess;
/**
 * Per-patient authorization.
 *
 * The JWT authorizer on the HTTP API proves WHO the caller is. It cannot express
 * "may read patient X" — that is a data question, so it is answered with data, on
 * every request. A care link revoked at 10:00 must take effect at 10:00, not
 * whenever a cached token happens to expire.
 */
const keys_js_1 = require("./keys.js");
const domain_js_1 = require("./domain.js");
/**
 * Thrown for BOTH "no care link" and "insufficient permission", and rendered as 404.
 *
 * A 403 would confirm that the patient exists, which leaks the membership of the
 * system to anyone holding any valid token.
 */
class PatientNotFoundError extends Error {
    statusCode = 404;
    constructor() {
        super('Not found');
        this.name = 'PatientNotFoundError';
    }
}
exports.PatientNotFoundError = PatientNotFoundError;
/**
 * The single gate every handler must pass through.
 *
 * `patientId` MUST come from the request path, never from the body — a body-supplied
 * id is an authorization bypass waiting to happen.
 */
async function requirePatientAccess(callerSub, patientId, permission, loadCareLink) {
    if (callerSub === patientId) {
        return { role: 'SELF', patientId, permissions: domain_js_1.ALL_PERMISSIONS };
    }
    const link = await loadCareLink(patientId, callerSub);
    if (link?.status !== 'ACTIVE' || link.revokedAt != null) {
        throw new PatientNotFoundError();
    }
    const granted = (link.permissions ?? []).filter(isPermission);
    if (!granted.includes(permission)) {
        throw new PatientNotFoundError();
    }
    return { role: 'CAREGIVER', patientId, permissions: granted };
}
function isPermission(value) {
    return domain_js_1.ALL_PERMISSIONS.includes(value);
}
/** Convenience for building the DynamoDB key a loader needs. */
exports.careLinkLookupKey = keys_js_1.careLinkKey;
//# sourceMappingURL=authz.js.map